import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { isActiveInsider } from "../visibilityFunctions/shared-utils";
import { GoToMembershipSettingsCTA, InsiderBenefitsLearnMoreCTA } from "./ctas";
export var BenefitsIA = function BenefitsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return isActiveInsider() ? INSIDER_RETAILER(strictLocalize) : NON_INSIDER_RETAILER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return isActiveInsider() ? GoToMembershipSettingsCTA(strictLocalize) : InsiderBenefitsLearnMoreCTA(strictLocalize);
};
var INSIDER_RETAILER = function INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize)];
    }
  };
};
var NON_INSIDER_RETAILER = function NON_INSIDER_RETAILER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INSIDER_MEMBERSHIP_BENEFITS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize)];
    }
  };
};
var INSIDER_MEMBERSHIP_BENEFITS = function INSIDER_MEMBERSHIP_BENEFITS(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "wAVSN/",
    defaultMessage: [{
      "type": 0,
      "value": "Over het Insider-lidmaatschap"
    }]
  }) : strictLocalize({
    id: "qTpQWl",
    defaultMessage: [{
      "type": 0,
      "value": "Voordelen van een Insider-lidmaatschap"
    }]
  });
};
var WITH_YOUR_INSIDER_MEMBERSHIP = function WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "ftgnjU",
    defaultMessage: [{
      "type": 0,
      "value": "Met je Insider-lidmaatschap krijg je toegang tot gratis verzending van duizenden door Faire geselecteerde merken. Bovendien krijg je exclusieve, vroege toegang tot de virtuele beurzen van Faire en de nieuwste merken op onze site. Om je Insider-lidmaatschapsgegevens te bekijken, klik je op de onderstaande knop en ga je naar het tabblad ‘Insider-lidmaatschap’ in je Accountinstellingen."
    }]
  });
};
var WHEN_YOU_SIGN_UP_FOR_INSIDER = function WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize) {
  return strictLocalize({
    id: "x20m8m",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je je aanmeldt voor een Insider-lidmaatschap, krijg je gratis verzending van duizenden door Faire geselecteerde merken. Bovendien krijg je exclusieve, vroege toegang tot de virtuele beurzen van Faire en nieuwe merken op de website. Registreer je voor een gratis proefperiode van 30 dagen om toegang te krijgen tot deze voordelen. Na afloop van de proefperiode wordt het bedrag maandelijks in rekening gebracht op de door jou gekozen betaalmethode."
    }]
  });
};